import { render, staticRenderFns } from "./QuoteFormRecordType.vue?vue&type=template&id=6acc227b&scoped=true&"
import script from "./QuoteFormRecordType.vue?vue&type=script&lang=ts&"
export * from "./QuoteFormRecordType.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteFormRecordType.vue?vue&type=style&index=0&id=6acc227b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acc227b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
